import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const SidebarItem = ({ icon, label, to, expanded, onClick, active, subItems = [] }) => {
  const navigate = useNavigate();
  const isImage = typeof icon === "string";
  const location = useLocation();
  const isActive =
    location.pathname === to ||
    subItems.some((item) => location.pathname === item.to);

  const [open, setOpen] = useState(isActive);

  const handleClick = () => {
    if (subItems.length > 0) {
      setOpen(!open);
    } else {
      navigate(to);
      onClick && onClick();
    }
  };

  return (
    <>
      <li className={`sidebar-item ak-text-md  ${expanded ? "expanded" : ""}`}>
        <div
          className={`sidebar-link align-content-center ${active ? " active" : ""}`}
        
          onClick={handleClick}
          style={{ cursor: "pointer" }}
        >
          <span className="icon">
            {isImage ? (
              <img src={icon} alt={`${label} icon`} className="icon-image" />
            ) : (
              icon
            )}
          </span>
          {expanded && <span className="label ak-text-md">{label}</span>}
        </div>
      </li>

      {open && expanded && subItems.length > 0 && (
        <ul className="nav flex-column ms-4">
          {subItems.map((item, index) => {
            const subActive = location.pathname === item.to;
            return (
              <li className="nav-item" key={index}>
                <div
                  onClick={() => {
                    navigate(item.to);
                    onClick && onClick();
                  }}
                  className={`d-flex align-items-center px-4 py-2 rounded mb-1 ak-text-md ${
                    subActive
                      ? "textwhite fw-semibold"
                      : "textsec"
                  }`}
                  style={{ cursor: "pointer" }}
                >
                  <span className="me-2">{item.icon}</span>
                  {item.label}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

export default SidebarItem;
